import { render, staticRenderFns } from "./InboxUser.vue?vue&type=template&id=4d2f8959&scoped=true&"
import script from "./InboxUser.vue?vue&type=script&lang=js&"
export * from "./InboxUser.vue?vue&type=script&lang=js&"
import style0 from "./InboxUser.vue?vue&type=style&index=0&id=4d2f8959&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d2f8959",
  null
  
)

export default component.exports